<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 mb-6">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">

        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full md:w-1/2 px-3 pt-3 mb-0">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Prefix</label
            >
            <v-select
                v-model="formValues.prefix"
                :elevation="1"
                :items="prefixes"
                dense
                item-text="name"
                item-value="name"
                label="prefix"
                solo
            ></v-select>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >First Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="firstName"
                  v-model="formValues.firstName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Father Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="middleName"
                  v-model="formValues.middleName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Grandfather Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="lastName"
                  v-model="formValues.lastName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Gender</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="Male"
                  v-model="formValues.gender"
                  class="my-3 ml-5"
                  type="radio"
                  value="Male"
              />
              <label for="Male"> Male </label>
              <br/>

              <input
                  id="Female"
                  v-model="formValues.gender"
                  class="my-3 ml-5"
                  type="radio"
                  value="Female"
              />
              <label for="Female"> Female </label>
              <br/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Proffesion</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.healthProfessionId"
                  :elevation="1"
                  :items="PROFESSIONS"
                  :loading="professionLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Region</label
            >
            <v-select
                v-model="defaultRegion"
                :elevation="1"
                :items="REGIONS"
                :loading="regionLoading"
                dense
                item-text="name"
                item-value="id"
                solo
                @change="regionOnChange($event)"
            >
            </v-select>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Zone</label
            >
            <v-select
                v-model="defaultZone"
                :elevation="1"
                :items="FILTERED_ZONES"
                :loading="zoneLoading"
                dense
                item-text="name"
                item-value="id"
                solo
                @change="zoneOnChange($event)"
            >
            </v-select>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Woreda</label
            >
            <v-select
                v-model="formValues.woredaId"
                :elevation="1"
                :items="FILTERED_WOREDAS"
                :loading="woredaLoading"
                dense
                item-text="name"
                item-value="id"
                solo
                @change="woredaOnChange($event)"
            >
            </v-select>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label
                class="
                          block
                          uppercase
                          tracking-wide
                          text-gray-700 text-xs
                          font-bold
                          mb-2
                        "
            >Kebele</label
            >
            <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
            <input
                id="kebele"
                v-model="formValues.kebele"
                class="
                            shadow
                            appearance-none
                            border
                            rounded
                            w-full
                            py-2
                            px-3
                            text-gray-700
                            leading-tight
                            focus:outline-none focus:shadow-outline
                          "
                name
                type="text"
            />
            <!-- <span class="text-gray-600 text-xs italic text-red-700">{{
              errors[0]
            }}</span>
          </validation-provider> -->
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <v-checkbox v-model="formValues.unemployed" style="float: left; text-align: left; margin-top: 0;"
                        @change="unemployedChanged()"></v-checkbox>
            Unemployed?
          </div>
          <div v-if="!unemployed" class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
            <label
                class=" block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 "
            >Facility</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.facilityId"
                  :elevation="1"
                  :items="NEW_TRAINEE_FACILITIES"
                  :loading="facilityLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
              >
              </v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div v-if="!unemployed" class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Facility Email Address</label
            >
            <validation-provider v-slot="{ errors }">
              <input
                  id="facilityEmail"
                  v-model="formValues.facilityEmail"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="email"
              />
              <span
                  class="text-gray-600 text-xs italic text-red-700"
              >{{ errors[0] }}</span
              >
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Phone number</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^([+]2519|2519|09|9)\\d{8}|^(0|[+]251|251)\\d{9}',
              }"
            >
              <input
                  id="phoneNumber"
                  v-model="formValues.phoneNumber"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="number"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Employee Id</label
            >
            <!-- <validation-provider
              :rules="{
                required: true,
              }"
              v-slot="{ errors }"
            > -->
            <input
                id="employeeId"
                v-model="formValues.employeeId"
                class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                name
                type="text"
            />
            <!-- <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span> -->
            <!-- </validation-provider> -->
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 mt-2">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                mt-2
              "
            >License number</label
            >
            <!-- <validation-provider
              :rules="{
                required: true,
              }"
              v-slot="{ errors }"
            > -->
            <input
                id="licenseNumber"
                v-model="formValues.licenseNumber"
                class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                name
                type="text"
            />
            <!-- <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider> -->
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 mt-2">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                mt-2
              "
            >National ID</label
            >
            <!-- <validation-provider
              :rules="{
                required: true,
              }"
              v-slot="{ errors }"
            > -->
            <input
                id="licenseNumber"
                v-model="formValues.national_id"
                class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                name
                type="text"
            />

          </div>
        </div>

        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full">
            <button
                class="
                float-right
                shadow
                bg-teal-600
                hover:bg-teal-600
                focus:shadow-outline focus:outline-none
                text-white
                font-bold
                py-2
                px-4
                rounded
              "
                type="button"
                @click="submit()"
            >
              Update Trainee
            </button>
          </div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {max_value, min_value, required} from "vee-validate/dist/rules";
import {
  getFacilitiesByWoredaId,
  getHealthProfessions,
  getRegionList,
  getWoredaByZoneId,
  getZoneByRegionId,
} from "../../../utils/helper";
import {PrefixEnum} from "@/utils/enums";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("min_value", {
  ...min_value,
  message: "Invalid Value",
});
extend("max_value", {
  ...max_value,
  message: "Invalid Value",
});
export default {
  props: {
    newTrainee: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        firstName: "",
        middleName: "",
        lastName: "",
        healthProfessionId: null,
        woredaId: null,
        phoneNumber: "",
        kebele: null,
        national_id: "",
        prefix: "",
        licenseNumber: "",
        facilityEmail: null,
        unemployed: false,
        employeeId: null,
        facilityId: null,
        gender: "",
      },
      defaultRegion: null,
      REGIONS: [],
      defaultZone: null,
      PROFESSIONS: [],
      FILTERED_ZONES: [],
      FILTERED_WOREDAS: [],
      NEW_TRAINEE_FACILITIES: [],
      regionLoading: false,
      zoneLoading: false,
      woredaLoading: false,
      professionLoading: false,
      facilityLoading: false,
      prefixes: [],
      unemployed: false
    };
  },
  async created() {
    this.prefixes = await PrefixEnum;
    this.facilityLoading = true;
    if (this.newTrainee != null) {
      this.formValues = this.newTrainee;
      this.defaultRegion = this.formValues.woreda ? (this.formValues.woreda.zone ? (this.formValues.woreda.zone.regionId ? this.formValues.woreda.zone.regionId : null) : null) : null;
      this.defaultZone = this.formValues.woreda ? (this.formValues.woreda.zoneId ? this.formValues.woreda.zoneId : null) : null;
      if (this.defaultRegion) {
        this.regionOnChange(this.defaultRegion);
      }
      if (this.defaultZone) {
        this.zoneOnChange(this.defaultZone);
      }
      // let tempres = await LookupService.getAllUserFacilities();
      // this.NEW_TRAINEE_FACILITIES = tempres.data?.rows
      this.facilityLoading = false;
    }
  },
  async beforeMount() {
    this.regionLoading = true;
    this.professionLoading = true;
    this.REGIONS = await getRegionList();
    this.regionLoading = false;
    const healthProfs = await getHealthProfessions();
    this.PROFESSIONS = healthProfs?.rows.filter((data) => {
      return data.isActive == true;
    });
    this.professionLoading = false;
  },
  methods: {
    async regionOnChange(event) {
      this.zoneLoading = true;
      this.FILTERED_ZONES = [];
      this.FILTERED_WOREDAS = [];
      const regionId = event;
      this.FILTERED_ZONES = await getZoneByRegionId(regionId);
      this.zoneLoading = false;
    },
    async zoneOnChange(event) {
      this.woredaLoading = true;
      const zoneId = event;
      this.FILTERED_WOREDAS = await getWoredaByZoneId(zoneId);
      this.woredaLoading = false;
    },
    async woredaOnChange(event) {
      this.facilityLoading = true;
      const woredaId = event;
      this.NEW_TRAINEE_FACILITIES = await getFacilitiesByWoredaId(woredaId);
      this.facilityLoading = false;
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("updateTrainee", this.formValues);
      this.$emit("close");
    },
    unemployedChanged() {
      this.unemployed = !this.unemployed;
    }
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
